goog.provide("shadow.js.shim.module$cookies$default");
shadow.js.shim.module$cookies$default = esm_import$cookies.default;
